<template>
    <div id="email-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vue-headful :title="$t('registration-of-disciplines')" />
        <component :is="'VuePerfectScrollbar'" class="infinite_scroll_wrapper" ref="listScroll" :key="$vs.rtl">
            <vs-sidebar class="items-no-padding" parent="#email-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isEmailSidebarActive">
                <nazad />
                <SideBar @dataSET="dataSET" @click="click" />
            </vs-sidebar>
            <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0 px-2">
                <massege-advizer v-if="showNoDiscipline == true" :profileAdvisor="profileAdvisor" />
                <div class="email__actions flex items-center flex-wrap justify-between lg:p-2" v-if="showNoDiscipline == false">
                    <div class="flex items-center lg:hidden">
                        <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleEmailSidebar(true)" />
                    </div>
                    <Cycles/>
                    <content-top :cont="cont" @clickFinish="clickFinish"/>
                </div>
                <vs-row v-if="showNoDiscipline == false">
                    <Components/>
                    <ListDiscepline/>
                    <vs-alert v-if="cont">{{ $t("select_filter") }}</vs-alert>
                </vs-row>
                <vs-popup :title="$t('isc')+' '+acad_periodname" :active.sync="popupActive">
                    <ModalContent :data="data" :controlFormsData="controlFormsData" />
                </vs-popup>
            </div>
            <DisceplineView/>
        </component>
    </div>

</template>

<script>

import SideBar from "./components/SideBar.vue";
import Cycles from "./components/Cycles.vue";
import Components from "./components/Component.vue";
import ListDiscepline from "./components/ListDiscepline.vue";
import DisceplineView from "./components/DisciplineView.vue";
import ModalContent from "./components/Modal/ModalContent.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ModalRequestMixin from "./components/DisList/ModalRequestMixin";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import { mapActions } from "vuex";
import MassegeAdvizer from "@/pages/Home/RegistrationOfDisciplines/components/InsideComponents/MassegeAdvizer";
import Nazad from "@/pages/Home/RegistrationOfDisciplines/components/InsideComponents/Nazad";
import ContentTop from "@/pages/Home/RegistrationOfDisciplines/components/InsideComponents/ContentTop";

export default {
    components: {
        ContentTop,
        Nazad,
        MassegeAdvizer,
        SideBar,
        Cycles,
        Components,
        ListDiscepline,
        DisceplineView,
        VuePerfectScrollbar,
        ModalContent
    },
    mixins: [ModalRequestMixin],
    data() {
        return {
            showNoDiscipline: false,
            isEmailSidebarActive: true,
            clickNotClose: true,
            popupActive: false,
            data: [],
            controlFormsData: []
        };
    },
    watch: {
        windowWidth() {
            this.setSidebarWidth();
        },
        async popupActive() {
            if (this.popupActive) {

            }
        }
    },
    async mounted() {
        this.router_change();
        await this.STUDENT({ uid: this.$route.query.student });
    },
    computed: {
        student() {
            if (this.is_edvisor) {
                return this.$route.query.student;
            } else {
                return this.$store.state.user.user.profileId;
            }
        },
        windowWidth() {
            return this.$store.state.windowWidth;
        },
        profileAdvisor() {
            return this.$store.state.user.user.supervisors;
        },
        ...mapGetters({
            limit: "regis_discepline/limitDiscepline"
        }),
        is_edvisor() {
            return this.$store.state.user.user.role.is_supervisor;
        },
        ...mapGetters({
            obj: "regis_discepline/getFilter",
            cycles: "regis_discepline/getCicle"
        }),
        acad_periodname() {
            if (this.obj.acad_period) {
                if (this.obj.acad_period.name != null) {
                    return this.obj.acad_period.name.toLocaleLowerCase();
                }
            }
        },
        user() {
            return this.$store.state.user.user;
        },
        cont(){
            if (this.cycles.length>0||this.is_edvisor){
                return false
            }else{
                return true
            }
        }
    },

    async created() {
        this.setSidebarWidth();
    },
    methods: {
        ...mapMutations({
            SetListDiscepline: "regis_discepline/SetListDiscepline",
            SET_CICLE: "regis_discepline/SET_CICLE",
            CLEAR_COMPONENTS: "regis_discepline/CLEAR_COMPONENTS"
        }),
        ...mapActions({
            STATUS_INFO: "regis_discepline/STATUS_INFO",
            STUDENT: "regis_discepline/STUDENT"
        }),
        dataSET(val) {
            this.data = val;
            if (this.windowWidth < 992) {
                this.isEmailSidebarActive = false;
            }
        },
        click(val) {
            if (this.cycles.length == 0 || val == false) {
                this.showNoDiscipline = true;
            } else {
                this.showNoDiscipline = false;
            }
        },
        async clickFinish() {
            try {
                this.popupActive = true;
                this.$vs.loading();
                await this.thisRequest();
                await this.itocGet();
                this.$vs.loading.close();
            } catch (e) {
                console.log(e);
            }
        },
        async itocGet() {

            var obj = [];
            var route = this.$route.query;
            await this.$http
                .get("user/my_discipline/control_forms/", {
                    params: {
                        study_year: route.study_year,
                        study_plan: route.study_plan
                    }
                })
                .then((response) => {
                    obj = response.data;
                });
            if (obj[0]) {
                this.controlFormsData = obj[0].disciplines;
            }
        },

        toggleEmailSidebar(value = false) {
            if (!value) {
                this.closeMailViewSidebar();
                if (this.clickNotClose) {
                    return;
                }
            }
            this.isEmailSidebarActive = value;
        },

        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.clickNotClose = false;
                this.isEmailSidebarActive = true;
            } else {
                this.isEmailSidebarActive = this.clickNotClose = true;
            }
        },

        router_change() {
            if (this.user.role.is_student) {
                if (this.$route.query.student !== this.user.profileId) {
                    let queries = { student: this.user.profileId, ...this.$route.query };
                    this.$router.replace({ name: this.$route.name, query: queries });
                }
            }
        }
    },
    destroyed() {
        this.SetListDiscepline([]);
        this.SET_CICLE([]);
        this.CLEAR_COMPONENTS();
    }
};

</script>
<style>
.con-vs-tabs .con-slot-tabs {
    position: relative;
    display: block;
    overflow: visible !important;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

</style>
